import { Flex, Text } from "@chakra-ui/react";

export default function CartItem({ product }) {
  const { name, price, quantity } = product;
  return (
    <Flex width="100%" pt="3" px="5" justifyContent="space-between">
      <Text fontWeight="400" color="detailsColor">
        {`${name} x ${quantity}`}
      </Text>
      <Text color="detailsColor" fontWeight="400">
        ₹{parseFloat(quantity * price).toFixed(2)}
      </Text>
    </Flex>
  );
}
